/** Hub WebSocket — mọi social.{apex} dùng chung hub (Plan A).
 *  Interim: chatapi.gmv.asia (cert sẵn). Cutover: wss://socket.gmv.asia sau khi DNS+SSL.
 */
export function resolveSocketUrl() {
    const fromEnv = (process.env.VUE_APP_SOCKET_URL || "").trim();
    if (fromEnv) {
        return fromEnv.replace(/\/$/, "");
    }
    return "wss://chatapi.gmv.asia";
}
